import { Injectable } from '@angular/core';
import { CanDeactivate, Router } from '@angular/router';
import { BaseModalService } from '../shared/services/base-modal.service';

@Injectable({
  providedIn: 'root'
})
export class CanDeactivateGuard implements CanDeactivate<unknown> {
  constructor(
    public baseModalService: BaseModalService,
    private router: Router,
  ) { }

  async canDeactivate() {
    if (this.router.getCurrentNavigation()?.extras?.state?.confirmDeactivate) {
      const modalConfig = {
        text: 'Sair e <strong>não salvar </strong>a alteração?',
        confirmBtnText: 'Sim',
        deniedBtnText: 'Cancelar',
      };

      return await this.baseModalService.showConfirmationModal(modalConfig).afterClosed().toPromise();
    } else {
      return true;
    }
  }
}
